export default "__VITE_ASSET__DtmhefUR__"